<template>
  <v-layout row fill-height>
    <v-flex xs12>
      <v-toolbar class="grey lighten-5 elevation-1">
        <v-toolbar-title
          class="subheading"
          @click="campaignTitleDialog = true"
          >{{ campaignTitle }}</v-toolbar-title
        >
      </v-toolbar>
      <v-dialog
        v-model="campaignTitleDialog"
        max-width="95%"
        :origin="'top center'"
      >
        <v-card class="pa-2">
          <v-card-text class="text-xs-center">
            {{ campaignTitle }}
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-window v-model="bottomNav" touchless class="fill-height">
        <v-window-item>
          <v-card tile>
            <v-layout row>
              <v-flex
                xs6
                class="green lighten-1 text-xs-center white--text py-2"
              >
                <span class="headline">{{ stats.locally_updated }}</span>
                <div>ayant été rejoint</div>
              </v-flex>
              <v-flex
                xs6
                class="purple lighten-1 text-xs-center white--text py-2"
              >
                <span class="headline">{{
                  visibleSolicitationLists.length
                }}</span>
                <div>sur la liste actuelle</div>
              </v-flex>
            </v-layout>
          </v-card>
          <div class="text-xs-center py-4" v-show="!listLoaded">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <p class="mt-2 text--secondary" v-show="!isInitialPulling">
              Chargement de la liste.
            </p>
            <p class="mt-2 text--secondary" v-show="isInitialPulling">
              Chargement initial de la liste.<br />
              Cela peut prendre quelques instants.
            </p>
          </div>
          <v-list three-line v-show="listLoaded" class="py-0">
            <v-subheader v-show="solicitationLists.length > 0"
              >Liste des électeurs</v-subheader
            >
            <v-list-tile
              :key="0"
              :disabled="true"
              :style="{ opacity: 0.5 }"
              v-show="solicitationLists.length === 0"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  La liste des électeurs est vide.
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(items, key, index) in byAddressSolicitationLists">
              <template v-for="item in items">
                <v-list-tile
                  :key="item.local_id"
                  avatar
                  ripple
                  :class="{ grey: isOdd(index), 'lighten-5': isOdd(index) }"
                  @click="
                    selectSolicitationList(item, false, windowIndexes.elector)
                  "
                  :disabled="isSolicitationListPushed(item)"
                  :style="{ opacity: isSolicitationListPushed(item) ? 0.5 : 1 }"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-icon small v-show="isSolicitationListPushed(item)"
                        >check</v-icon
                      >
                      {{ item.last_name }}, {{ item.first_name }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title
                      :class="{
                        'ml-4': isSolicitationListPushed(item),
                        'ml-1': !isSolicitationListPushed(item),
                      }"
                    >
                      {{ item.gender }} - {{ item.age }} ans &bull;
                      {{ item.complete_address }}, {{ item.city }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-avatar
                    v-if="item.score"
                    class="mt-1 white--text"
                    :color="
                      getScoreByCode(item.score).background || 'grey lighten-1'
                    "
                    :style="{
                      opacity: isSolicitationListPushed(item) ? 0.5 : 1,
                    }"
                  >
                    {{ item.score }}
                  </v-list-tile-avatar>
                  <v-btn icon ripple color="blue" dark style="{right: 5%}" @click.stop="navigateMapToSelectedPosition(item)">
                    <v-icon dark>my_location</v-icon>
                  </v-btn>
                </v-list-tile>
              </template>
              <v-divider :key="'divider-' + index"></v-divider>
            </template>
          </v-list>
        </v-window-item>
        <v-window-item>
          <v-toolbar dark color="primary" dense extended :extension-height="32">
            <v-toolbar-title class="white--text subheading"
              >{{ selectedSolicitationList.last_name }},
              {{ selectedSolicitationList.first_name }}</v-toolbar-title
            >
            <template v-slot:extension>
              <v-toolbar-title class="body-1 ml-0">
                <span
                  >{{ selectedSolicitationList.gender }} -
                  {{ selectedSolicitationList.age }} ans</span
                >
                <span class="pl-2 pr-2">•</span>
                <span
                  >{{ selectedSolicitationList.complete_address }},
                  {{ selectedSolicitationList.city }}</span
                >
              </v-toolbar-title>
            </template>
            <v-menu transition="slide-y-transition" bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  v-show="
                    selectedSolicitationListHouseholdSolicitationLists.length >
                    1
                  "
                >
                  <v-icon small>home</v-icon>
                  <v-icon small>arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <template
                  v-for="householdSolicitationListItem in selectedSolicitationListHouseholdSolicitationLists"
                >
                  <v-list-tile
                    :class="{
                      'text--disabled':
                        selectedSolicitationList.voter_id ===
                        householdSolicitationListItem.voter_id,
                    }"
                    :key="householdSolicitationListItem.local_id"
                    @click="
                      selectSolicitationList(
                        householdSolicitationListItem,
                        true
                      )
                    "
                  >
                    <v-list-tile-title class="body-1">
                      {{ householdSolicitationListItem.last_name }},
                      {{ householdSolicitationListItem.first_name }} ({{
                        householdSolicitationListItem.gender
                      }}) - {{ householdSolicitationListItem.age }} ans
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn icon ripple color="blue" dark right @click.stop="navigateMapToSelectedPosition(false)">
              <v-icon dark>my_location</v-icon>
            </v-btn>
            <v-menu transition="slide-y-transition" bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon dark>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="scriptDialog = true">
                  <v-list-tile-title class="body-1"
                    >Afficher le laïus
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-dialog v-model="scriptDialog" max-width="95%">
            <v-card class="amber lighten-4 pa-2">
              <v-card-title>
                <span class="title">Laïus</span>
              </v-card-title>
              <v-card-text class="pt-0">
                {{ selectedSoliciationListScript }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="scriptDialog = false" color="secondary">
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-form
            ref="selectedSolicitationListForm"
            v-model="selectedSolicitationListForm"
            class="mt-3"
          >
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Téléphone (maison)"
                    v-model="selectedSolicitationList.phone_household"
                    mask="phone"
                    validate-on-blur
                    :rules="phoneRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Téléphone (mobile)"
                    v-model="selectedSolicitationList.phone_principal"
                    mask="phone"
                    validate-on-blur
                    :rules="phoneRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Adresse courriel"
                    type="email"
                    v-model="selectedSolicitationList.email"
                    validate-on-blur
                    :rules="emailRules"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    label="Pointage"
                    v-model="selectedSolicitationList.score"
                    :items="scoreChoices"
                    item-text="text"
                    item-value="code"
                    solo
                    :color="
                      selectedSolicitationList.score
                        ? getScoreByCode(selectedSolicitationList.score)
                            .background
                        : 'white'
                    "
                    :background-color="
                      selectedSolicitationList.score
                        ? getScoreByCode(selectedSolicitationList.score)
                            .background
                        : ''
                    "
                    required
                    :rules="scoreRules"
                  >
                    <template v-slot:selection="{ item }">
                      <span class="flex" :class="item.color">{{
                        item.text
                      }}</span>
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.indentText" />
                      </v-list-tile-content>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout
                v-if="
                  selectedSolicitationList.score === 'S' ||
                  selectedSolicitationList.score === 'I'
                "
              >
                <v-flex xs12>
                  <v-subheader class="pa-0"
                    >Information complémentaire</v-subheader
                  >
                  <div>
                    <v-checkbox
                      v-model="
                        selectedSolicitationList.send_membership_form_link
                      "
                      :label="`Envoyer le lien menant au formulaire de membership par courriel`"
                      :disabled="!isValidEmail(selectedSolicitationList.email)"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="selectedSolicitationList.send_election_location"
                      :label="`Envoyer le lieu de votation par courriel`"
                      :disabled="!isValidEmail(selectedSolicitationList.email)"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="selectedSolicitationList.send_candidate_bio"
                      :label="`Envoyer la bio du candidat par courriel`"
                      :disabled="!isValidEmail(selectedSolicitationList.email)"
                    ></v-checkbox>
                  </div>
                  <div>
                    <v-select
                      v-model="selectedSolicitationList.selected_issues_ids"
                      :items="issueChoices"
                      attach
                      chips
                      outline
                      label="Enjeux"
                      item-text="label"
                      item-value="id"
                      multiple
                      ref="selectedSolicitationListSelectedIssuesIdsSelect"
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index < 3">
                          <span>{{ item.label }}</span>
                        </v-chip>
                        <span v-if="index === 3" class="grey--text caption">
                          ( +{{
                            selectedSolicitationList.selected_issues_ids
                              .length - 3
                          }}
                          <span
                            v-show="
                              selectedSolicitationList.selected_issues_ids
                                .length -
                                3 <
                              2
                            "
                            >autre</span
                          >
                          <span
                            v-show="
                              selectedSolicitationList.selected_issues_ids
                                .length -
                                3 >=
                              2
                            "
                            >autres</span
                          >
                          )
                        </span>
                      </template>
                      <template v-slot:append-item>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            @click="
                              $refs.selectedSolicitationListSelectedIssuesIdsSelect.isMenuActive = false
                            "
                            color="primary"
                          >
                            OK
                          </v-btn>
                        </v-card-actions>
                      </template>
                    </v-select>
                  </div>
                  <div>
                    <v-textarea
                      v-model="selectedSolicitationList.notes"
                      auto-grow
                      box
                      label="Notes"
                      rows="1"
                    ></v-textarea>
                  </div>
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <v-btn
                  round
                  color="primary"
                  dark
                  large
                  @click="saveSelectedSolicitationList"
                >
                  Confirmer
                </v-btn>
              </div>
            </v-container>
          </v-form>
        </v-window-item>
        <v-window-item>
          <div ref="mapCanvas" class="map-canvas">
            <GmapMap
              v-show="showMap"
              :center="{ lat: 45.508888, lng: -73.561668 }"
              :zoom="15"
              map-type-id="terrain"
              ref="gmapRef"
              class="map-canvas"
            >
              <!-- v-for="(m, index) in markers" -->
              <!-- :key="index" -->
              <!-- :position="m.position" -->
              <!-- :clickable="true" -->
              <!-- :draggable="true" -->
              <!-- <GmapMarker @click="center = m.position" />-->
            </GmapMap>


            <v-btn
              v-show="!showMapOptions"
              color="white"
              class="black--text"
              style="top: 3%; box-shadow: 1.5px 1.5px rgb(189, 189, 189);"
              left
              absolute
              fab
              icon
              @click="switchShowMapOptions()"
            >
              <v-icon>settings</v-icon>
            </v-btn>

            <div class="map-options-background" v-show="showMapOptions">
              <h2 style="text-align: center;">Options</h2>
              <v-btn
                class="exit-map-options-button"
                absolute
                :ripple="false"
                icon
                small
                @click="switchShowMapOptions()"
              >
                <v-icon 
                  class="exit-map-options-icon"
                  color="grey"
                  small
                >
                  close
                </v-icon>
              </v-btn>
              <v-checkbox 
                label="Montrer le trajet"
                class="checkbox-padding"
                v-model="showDirections"
                @change="findAndTraceMapDirections()"
              />
              <v-checkbox 
                label="Montrer tous les électeurs de la liste"
                class="checkbox-padding"
                v-model="showSolicitationListMarker"
                @change="createSolicitationListMarker()"
              />
              <v-checkbox 
                label="Cacher les électeurs déjà pointés"
                class="checkbox-padding"
                v-model="showTaggedSolicitationListMarker"
                @change="createSolicitationListMarker()"
              />
            </div>

            <v-btn
              color="primary"
              class="btn-directions white--text"
              bottom
              right
              fab
              absolute
              @click="gotoMapDirections()"
            >
              <v-icon class="pa-0 ma-0">directions</v-icon>
            </v-btn>

            <v-btn
              color="white"
              class="btn-my-position primary--text"
              bottom
              left
              fab
              absolute
              @click="navigateMapToMyPosition()"
            >
              <v-icon class="pa-0 ma-0">my_location</v-icon>
            </v-btn>
          </div>
        </v-window-item>
        <v-window-item>
          <v-toolbar dark color="primary">
            <v-toolbar-title class="text-xs-center"
              >Synchronisation à Coaliste</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-menu transition="slide-y-transition" bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon dark>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="removePushedSolicitations">
                  <v-list-tile-title class="body-1"
                    >Masquer les solicitations synchronisées</v-list-tile-title
                  >
                </v-list-tile>
                <v-list-tile @click="restoreDeletedSolicitations">
                  <v-list-tile-title class="body-1"
                    >Afficher les solicitations synchronisées</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-subheader class="mt-1">Solicitations sur l'appareil</v-subheader>
          <v-layout row>
            <v-flex xs6>
              <v-card tile flat>
                <v-card-text
                  class="
                    text-xs-center
                    white
                    lighten-4
                    grey--text
                    text--darken-2
                  "
                >
                  <span class="headline">{{ stats.locally_unpushed }}</span>
                  <div>à synchroniser</div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs6>
              <v-card tile flat>
                <v-card-text class="text-xs-center white lighten-4">
                  <span class="headline">{{ stats.locally_pushed }}</span>
                  <div v-show="stats.locally_pushed < 2">synchronisée</div>
                  <div v-show="stats.locally_pushed >= 2">synchronisées</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-subheader class="grey lighten-4">
            <span>Solicitations dans Coaliste</span>
            <v-progress-circular
              indeterminate
              v-show="pullingStats"
              color="secondary"
              class="ml-3"
              style="opacity: 0.5"
            ></v-progress-circular>
          </v-subheader>
          <v-layout row>
            <v-flex xs6>
              <v-card tile flat>
                <v-card-text
                  class="
                    text-xs-center
                    grey
                    lighten-4
                    grey--text
                    text--darken-2
                  "
                >
                  <span class="headline">{{ stats.total_scored }}</span>
                  <div>ayant été rejoint</div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs6>
              <v-card tile flat>
                <v-card-text class="text-xs-center grey lighten-4">
                  <span class="headline">{{ stats.total_remaining }}</span>
                  <div>restant sur la liste</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-container>
            <div class="caption mt-1" v-if="stats.pushed_at">
              Dernière synchronisation:
              <em>{{ formatTimestamp(stats.pushed_at) }}</em>
            </div>
            <v-switch
              color="primary"
              v-model="autoSyncingEnabled"
              label="Synchronisation automatique"
            ></v-switch>
            <v-btn
              color="secondary"
              @click="exportInCSV"
            >
              Exporter en format CSV
            </v-btn>
            <v-btn
              color="primary"
              @click="clickPushSolicitationLists"
              :disabled="stats.locally_unpushed === 0 || syncing"
            >
              Synchroniser
            </v-btn>
            <v-progress-circular
              indeterminate
              v-show="syncing"
              color="primary"
            ></v-progress-circular>
          </v-container>
        </v-window-item>
      </v-window>
      <v-bottom-nav
        class="bottom-navigation"
        :active.sync="bottomNav"
        :value="true"
        fixed
        dark
        app
        @update:active="onUpdateBottomNavActive"
      >
        <v-btn>
          <span>Liste</span>
          <v-icon>view_list</v-icon>
        </v-btn>
        <v-btn>
          <span>Électeur</span>
          <v-icon>assignment_ind</v-icon>
        </v-btn>
        <v-btn>
          <span>Carte</span>
          <v-icon>map</v-icon>
        </v-btn>
        <v-btn>
          <span>Synchroniser</span>
          <v-icon>sync</v-icon>
        </v-btn>
      </v-bottom-nav>
      <v-snackbar
        v-model="snackbar.enabled"
        color="dark"
        :timeout="snackbar.timeout"
        class="ma-2"
        flat
        @click="snackbar.enabled = false"
      >
        {{ snackbar.message }}
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import { Auth } from "../auth";
import { Exchanger } from "../exchanger";
import issues from "../data/issues";
import moment from "moment";
import "moment/src/locale/fr-ca";
import { nSQL } from "@nano-sql/core";
import scores from "../data/scores";
import gmapsInit from "../gmaps";
import MiniCAQUtils from "../utils.js";
import { getGoogleMapsAPI } from "gmap-vue";

const SOLICITATION_LIST_EDITABLE_ATTRIBUTES = [
  "phone_household",
  "phone_principal",
  "email",
  "score",
  "send_membership_form_link",
  "send_election_location",
  "send_candidate_bio",
  "selected_issues_ids",
  "notes",
];

const MAP_SHOWINFO_DELAY = 250;
const MAP_ANIMATION_DELAY = 1000;
const MAP_ANIMATION_DURATION = 3000;
const emailRegex = new RegExp(/.+@.+/);
const phoneRegex = new RegExp(/^\d{10}$/);

export default {
  data() {
    return {
      showMap: false,
      satelliteMap: false,
      showMapOptions: false,
      showDirections: false,
      myPositionMarker: null,
      mapSelectedSolicitationListMarker: null,
      showSolicitationListMarker: false,
      showTaggedSolicitationListMarker: false,
      mapSolicitationListMarker: [],
      openedInfowindow: [],
      mapDirections: null,
      position: {},
      syncing: false,
      autoSyncingEnabled: false,
      bottomNav: 0,
      campaignTitleDialog: false,
      isInitialPulling: false,
      issueChoices: issues,
      listLoaded: false,
      locale: "fr-ca",
      mapLoaded: false,
      map: null,
      pullingStats: false,
      scoreChoices: scores,
      scriptDialog: false,
      selectedSolicitationList: {},
      selectedSolicitationListForm: true,
      selectedSolicitationListHouseholdSolicitationLists: [],
      sendCandidateBio: false,
      sendElectionLocation: false,
      sendMembershipFormLink: false,
      solicitationAssignation: {},
      solicitationLists: [],
      snackbar: {
        enabled: false,
        timeout: 6000,
        message: "",
      },
      stats: {
        total_scored: 0,
        total_qualified: 0,
        total_remaining: 0,
      },
      windowIndexes: {
        list: 0,
        elector: 1,
        map: 2,
        sync: 3,
      },
      windowYOffset: 56,
      windowYPositions: [0, 0, 0, 0],
      emailRules: [
        (v) =>
          !v || emailRegex.test(v) || "L'adresse courriel n'est pas valide",
      ],
      phoneRules: [
        (v) => !v || phoneRegex.test(v) || "Le numéro n'est pas valide",
      ],
      scoreRules: [
        (v) => !!v || "Le pointage est obligatoire",
        (v) =>
          !v ||
          -1 !== _.findIndex(this.scoreChoices, { code: v }) ||
          "Le pointage n'est pas valide",
      ],
    };
  },

  created: function () {
    this.debouncedCheckSelectedSolicitationListEmail = _.debounce(
      this.checkSelectedSolicitationListEmail,
      300
    );
  },

  watch: {
    "selectedSolicitationList.email": function () {
      this.debouncedCheckSelectedSolicitationListEmail();
    },

    async bottomNav(val, oldVal) {
      if (oldVal === 0) {
        this.windowYPositions[oldVal] = window.scrollY;
      }

      if (
        (val === this.windowIndexes.elector ||
          val === this.windowIndexes.map) &&
        !this.selectedSolicitationList.local_id
      ) {
        if (this.solicitationLists[0]) {
          this.selectSolicitationList(
            this.sortedUnscoredVisibleSolicitationLists[0] ||
              this.solicitationLists[0]
          );
        } else {
          this.snackbar.message = "Il n'y a aucun électeur sur la liste.";
          this.snackbar.enabled = true;
          this.bottomNav = -1;
        }
      }
      if (this.bottomNav === this.windowIndexes.map) {
        this.showMap = true;
      } else {
        this.showMap = false;
      }
    },

    async showMap(val, oldVal) {
      if (val === true) {
        await this.refreshMap();
      }
    },

    autoSyncingEnabled(value) {
        if(typeof this.solicitationAssignation.id === 'undefined') {
            return;
        }

        const localStorageItemKey = 'solicitation-' + this.solicitationAssignation.id + '-autosync';

        localStorage.setItem(localStorageItemKey, value + '');
    }
  },

  computed: {
    selectedSoliciationListScript() {
      if (!this.solicitationAssignation.id) {
        return "";
      }

      if (!this.selectedSolicitationList.local_id) {
        return this.solicitationAssignation.script;
      } else {
        return this.solicitationAssignation.script
          .replace(/\[courtoisie\]/g, this.selectedSolicitationList.courtoisie)
          .replace(/\[nom\]/g, this.selectedSolicitationList.last_name)
          .replace(
            /\[benevole\]/g,
            `${Auth.user().first_name} ${Auth.user().last_name}`
          )
          .replace(
            /\[circonscription\]/g,
            this.solicitationAssignation.district_name
          )
          .replace(
            /\[candidat\]/g,
            this.solicitationAssignation.district_candidate
          );
      }
    },

    visibleSolicitationLists() {
      return _.filter(this.solicitationLists, function (solicitationList) {
        return (
          !solicitationList.remotely_deleted &&
          !solicitationList.locally_deleted
          // && (!solicitationList.score || solicitationList.score === 'AB')
        );
      });
    },

    sortedVisibleSolicitationLists() {
      return _.orderBy(
        this.visibleSolicitationLists,
        ["district_id", "section_number", "voter_number"],
        ["asc", "asc", "asc"]
      );
    },

    scoredSolicitationLists() {
      return _.filter(this.solicitationLists, function (solicitationList) {
        return solicitationList.score && solicitationList.score !== "AB";
      });
    },

    sortedUnscoredVisibleSolicitationLists() {
      return _.filter(
        this.sortedVisibleSolicitationLists,
        function (solicitationList) {
          return !solicitationList.score || solicitationList.score === "AB";
        }
      );
    },

    campaignTitle() {
      if (!this.solicitationAssignation.id) {
        return "";
      }

      return this.solicitationAssignation.label;
    },

    byAddressSolicitationLists() {
      const result = {};

      const sortedVisibleSolicitationLists =
        this.sortedVisibleSolicitationLists;

      for (
        let i = 0, len = sortedVisibleSolicitationLists.length;
        i < len;
        i++
      ) {
        let solicitationList = sortedVisibleSolicitationLists[i];

        if (!result[solicitationList.complete_address]) {
          result[solicitationList.complete_address] = [];
        }

        result[solicitationList.complete_address].push(solicitationList);
      }

      return result;
    },
    google: getGoogleMapsAPI,
  },

  async mounted() {
    const currentSolicitationAssignation = await Auth.getCurrentSolicitationAssignation();

    if (! currentSolicitationAssignation) {
      this.solicitationAssignation = {};
      await this.$router.push({ name: "campaigns.index" });

      return;
    }

    this.solicitationAssignation = currentSolicitationAssignation;

    this.autoSyncingEnabled = localStorage.getItem('solicitation-' + this.solicitationAssignation.id + '-autosync') === 'true';

    this.refreshSolicitationAssignation();

    Exchanger.pullSolicitationLists(this.solicitationAssignation);

    setInterval(function () {
      if (!Exchanger.isOffline() && this.autoSyncingEnabled) {
        this.pushSolicitationLists();
      }
    }.bind(this), 10000);

    Exchanger.$on('solicitation-lists-pulled', function (solicitationAssignation) {
      if (solicitationAssignation.id === this.solicitationAssignation.id) {
        // this.pullingStats = false;
        this.refreshList();
      }
    }.bind(this));

    Exchanger.$on('solicitation-assignation-stats-pulled', function (solicitationAssignation) {
      if (solicitationAssignation.id === this.solicitationAssignation.id) {
        this.pullingStats = false;
        this.refreshStats();
      }
    }.bind(this));

    Exchanger.$on('solicitation-lists-pushed', function (solicitationAssignation) {
      if (solicitationAssignation.id === this.solicitationAssignation.id) {
        this.refreshSolicitationAssignation();
        this.pullingStats = true;
        Exchanger.pullSolicitationLists(this.solicitationAssignation);
      }
    }.bind(this));

    this.$refs.gmapRef.$mapPromise.then(async (map) => {
      await this.refreshPosition();
      map.panTo(this.position.latLng);
      this.map = map;
    });
  },

  methods: {
    exportInCSV: function () {
      nSQL("solicitation_lists")
      .query('select')
      .toCSV(true)
      .then((csv) => {
          this.download(csv);
      });
    },

    download(data) {
      //Need a fancy name
      let currentdate = new Date();
      var datetime = currentdate.getDate() + "/"
                + (currentdate.getMonth() + 1) + "/"
                + currentdate.getFullYear();

      let filename = 'CAQ - solicitations '+datetime+'.csv';

      let element = document.createElement('a');
      element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(data));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();
      document.body.removeChild(element);
    },

    gotoMapDirections: function () {
      const ll =
        this.selectedSolicitationList.map_latitude +
        "," +
        this.selectedSolicitationList.map_longitude;
      switch (MiniCAQUtils.detectOS()) {
        case "Android":
          const label = encodeURI(
            this.selectedSolicitationList.complete_address
          );

          window.open(`geo:0,0?q=${ll} (${label})`, "_system");
          break;
        case "iOS":
          //cordova.InAppBrowser.open(`https://www.google.com/maps/dir/ma+position/${ll}`, '_system');
          //cordova.InAppBrowser.open(`http://maps.apple.com/?daddr=${ll}`, '_system');
          window.open(`maps:0,0?q=${ll}`, "_system");
          break;

        case "browser":
        default:
          window
            .open(`https://www.google.com/maps/dir/ma+position/${ll}`, "_blank")
            .focus();
          break;
      }
    },

    refreshPosition: async function () {
      if (navigator.geolocation) {
        const pos = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        this.position = {
          latLng: {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          },
        };
      }
    },

    navigateMapToMyPosition: async function () {
      if (!this.mapLoaded || !this.position || !this.position.latLng) {
        return;
      }
      this.$refs.gmapRef.$mapPromise.then(async (map) => {
        await this.refreshPosition();
        map.panTo(this.position.latLng);
        this.map = map;
      });
    },

    async findAndTraceMapDirections() {
      if (this.mapDirections != null) {
        this.mapDirections.setMap(null);
      }

      if (!this.showDirections) {
        return;
      }
      const directionsService = new this.google.maps.DirectionsService();
      if (this.mapDirections === null) {
        this.mapDirections = new this.google.maps.DirectionsRenderer();
      }

      this.mapDirections.setMap(this.map);
      this.mapDirections.setOptions({ suppressMarkers: true });

      directionsService
        .route({
          origin: {
            query: this.position.latLng.lat + "," + this.position.latLng.lng,
          },
          destination: {
            query:
              this.selectedSolicitationList.map_latitude +
              "," +
              this.selectedSolicitationList.map_longitude,
          },
          travelMode: google.maps.TravelMode.DRIVING,
        })
        .then((response) => {
          this.mapDirections.setDirections(response);
        })
        .catch((e) => window.alert("Directions request failed due to " + e));
    },

    switchShowMapOptions: function () {
      this.showMapOptions = !(this.showMapOptions);
    },

    createMyPositionMarker: async function () {
      if (this.myPositionMarker !== null) {
        this.myPositionMarker.setMap(null);
      }
      this.myPositionMarker = new google.maps.Marker({
        map: this.map,
        // icon: "blue",
        position: {
          lat: this.position.latLng.lat,
          lng: this.position.latLng.lng,
        },
        title: `Ma position`,
      });

      const infowindow = new google.maps.InfoWindow({
        content: `Ma position actuelle`,
        disableAutoPan: true,
      });

      this.myPositionMarker.addListener("click", () => {
        infowindow.open({
          anchor: this.myPositionMarker,
          map: this.map,
          shouldFocus: false,
        });
        this.openedInfowindow.push([infowindow, this.myPositionMarker]);
      });
      infowindow.addListener("closeclick", () => {
        for (let i = 0; i < this.openedInfowindow.length; i++) {
          if (this.openedInfowindow[i][0] == infowindow) {
            this.openedInfowindow.splice(i, 1);
            break;
          }
        }
      })
    },

    createSelectedSolicitationListMaker: async function () {
      // remove marker from map
      if (this.mapSelectedSolicitationListMarker !== null) {
        this.mapSelectedSolicitationListMarker.setMap(null);
      }

      // If we show every marker, we can skip this function
      if (this.showSolicitationListMarker) {
        return;
      }

      this.mapSelectedSolicitationListMarker = new google.maps.Marker({
        map: this.map,
        // icon: "blue",
        position: {
          lat: this.selectedSolicitationList.map_latitude,
          lng: this.selectedSolicitationList.map_longitude,
        },
        // position: this.position.latLng,
        // position: { lat: -25.363, lng: 131.044 },
        title: [
          `${this.selectedSolicitationList.last_name}, ${this.selectedSolicitationList.first_name}`,
          "•",
          `${this.selectedSolicitationList.gender} - ${this.selectedSolicitationList.age} ans`,
        ].join(" "),
        snippet: `${this.selectedSolicitationList.complete_address}, ${this.selectedSolicitationList.city}`,
        // animation: google.maps.Animation.BOUNCE,
      });

      var text1 = document.createElement("p");
      text1.textContent =this.selectedSolicitationList.last_name + ', ' + this.selectedSolicitationList.first_name + '•' + this.selectedSolicitationList.gender + ' - ' + this.selectedSolicitationList.age + 'ans';
      var text2 = document.createElement("p");
      text2.textContent = this.selectedSolicitationList.complete_address + ', ' + this.selectedSolicitationList.city;
      var profilButton = document.createElement("a");
      profilButton.textContent = 'Voir le profil';
      profilButton.addEventListener("click", () => {
        this.selectSolicitationList(this.selectedSolicitationList, false, this.windowIndexes.elector);
      })

      var infowindowContent = document.createElement("div");
      infowindowContent.appendChild(text1);
      infowindowContent.appendChild(text2);
      infowindowContent.appendChild(profilButton);

      const infowindow = new google.maps.InfoWindow({
        content: infowindowContent,
          disableAutoPan: true,
      });

      this.mapSelectedSolicitationListMarker.addListener("click", () => {
        infowindow.open({
          anchor: this.mapSelectedSolicitationListMarker,
          map: this.map,
          shouldFocus: false,
        });
        this.openedInfowindow.push([infowindow, this.mapSelectedSolicitationListMarker]);
      });

      infowindow.addListener("closeclick", () => {
        for (let i = 0; i < this.openedInfowindow.length; i++) {
          if (this.openedInfowindow[i][0] == infowindow) {
            this.openedInfowindow.splice(i, 1);
            break;
          }
        }
      })
    },

    createSolicitationListMarker: async function () {
      // remove markers from map
      if (this.mapSolicitationListMarker.length !== 0) {
        for (let i = 0; i < this.mapSolicitationListMarker.length; i++) {
          this.mapSolicitationListMarker[i].setMap(null);
        }
        this.mapSolicationListMarker = [];
      }
      console.log(this.showSolicitationListMarker);

      if (!this.showSolicitationListMarker) {
        this.createSelectedSolicitationListMaker();
        return;
      }

      // Make a list of every unique adress and link them to the associated electors
      var adressList = [];
      for (let i = 0; i < this.solicitationLists.length; i++) {
        if (this.solicitationLists[i].complete_address in adressList == false) {
          if (!this.showTaggedSolicitationListMarker == true || !(this.solicitationLists[i].score)) {
            adressList.push([this.solicitationLists[i].complete_address, []]);
          }
        }
      }

      for (let i = 0; i < adressList.length; i++) {
        for (let j = 0; j < this.solicitationLists.length; j++) {
          if (adressList[i][0] == this.solicitationLists[j].complete_address) {
            adressList[i][1].push(this.solicitationLists[j]);
          }
        }
      }

      for (let i = 0; i < adressList.length; i++) {
        // If the adress has the selected elector, we use the base marker, otherwise it's a blue marker
        if (this.selectedSolicitationList.complete_address == adressList[i][0]) {
          var adressInfo = []
          for (let j = 0; j < adressList[i][1].length; j++) {
            adressInfo.push(`${adressList[i][1][j].last_name}, ${adressList[i][1][j].first_name}`);
            adressInfo.push(" • ");
            adressInfo.push(`${adressList[i][1][j].gender} - ${adressList[i][1][j].age} ans`);
            if (j < adressList[i][1].length - 1) {
              adressInfo.push(" | ");
            }
          }

          let solicitationMarker = new google.maps.Marker({
            map: this.map,
            position: {
              lat: parseFloat(adressList[i][1][0].map_latitude),
              lng: parseFloat(adressList[i][1][0].map_longitude),
            },
            title: adressInfo.join(" "),
            snippet: `${adressList[i][1][0].complete_address}, ${adressList[i][1][0].city}`,
            // animation: google.maps.Animation.BOUNCE,
          });
          
          var text1 = document.createElement("p");
          text1.textContent = adressInfo;
          var text2 = document.createElement("p");
          text2.textContent = adressList[i][1][0].complete_address + ', ' + adressList[i][1][0].city;
          var profilButton = document.createElement("a");
          profilButton.textContent = 'Voir le profil';
          profilButton.addEventListener("click", () => {
            this.selectSolicitationList(this.selectedSolicitationList, false, this.windowIndexes.elector);
          });

          var infowindowContent = document.createElement("div");
          infowindowContent.appendChild(text1);
          infowindowContent.appendChild(text2);
          infowindowContent.appendChild(profilButton);

          // addlister pour clicker vers la page de l'electeur
          const infowindow = new google.maps.InfoWindow({
            content: infowindowContent,
              disableAutoPan: true,
          });

          solicitationMarker.addListener("click", () => {
            infowindow.open({
              anchor: solicitationMarker,
              map: this.map,
              shouldFocus: false,
            });
            this.openedInfowindow.push([infowindow, solicitationMarker]);
          });

          infowindow.addListener("closeclick", () => {
            for (let i = 0; i < this.openedInfowindow.length; i++) {
              if (this.openedInfowindow[i][0] == infowindow) {
                this.openedInfowindow.splice(i, 1);
                break;
              }
            }
          })

          this.mapSolicitationListMarker.push(solicitationMarker);
        }
        else {
          var adressInfo = []
          for (let j = 0; j < adressList[i][1].length; j++) {
            adressInfo.push(`${adressList[i][1][j].last_name}, ${adressList[i][1][j].first_name}`);
            adressInfo.push(" • ");
            adressInfo.push(`${adressList[i][1][j].gender} - ${adressList[i][1][j].age} ans`);
            if (j < adressList[i][1].length - 1) {
              adressInfo.push(" | ");
            }
          }

          let solicitationMarker = new google.maps.Marker({
            map: this.map,
            position: {
              lat: parseFloat(adressList[i][1][0].map_latitude),
              lng: parseFloat(adressList[i][1][0].map_longitude),
            },
            icon:"http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
            title: adressInfo.join(" "),
            snippet: `${adressList[i][1][0].complete_address}, ${adressList[i][1][0].city}`,
            // animation: google.maps.Animation.BOUNCE,
          });

          var text1 = document.createElement("p");
          text1.textContent = adressInfo;
          var text2 = document.createElement("p");
          text2.textContent = adressList[i][1][0].complete_address + ', ' + adressList[i][1][0].city;
          var profilButton = document.createElement("a");
          profilButton.textContent = 'Voir le profil';
          profilButton.addEventListener("click", () => {
            this.selectSolicitationList(adressList[i][1][0], false, this.windowIndexes.elector);
          });

          var switchProfilButton = document.createElement("button");
          switchProfilButton.className = "switchProfilButton";

          var switchProfilIcon = document.createElement("span");
          switchProfilIcon.className = "mdi--crosshairs-gps";
          switchProfilButton.appendChild(switchProfilIcon);

          switchProfilButton.addEventListener("click", () => {
            this.selectedSolicitationList = adressList[i][1][0];
            this.refreshMap();
          })

          var infowindowContent = document.createElement("div");
          infowindowContent.appendChild(text1);
          infowindowContent.appendChild(text2);
          infowindowContent.appendChild(profilButton);
          infowindowContent.appendChild(switchProfilButton);

          const infowindow = new google.maps.InfoWindow({
            content: infowindowContent,
              disableAutoPan: true,
              
          });

          solicitationMarker.addListener("click", () => {
            infowindow.open({
              anchor: solicitationMarker,
              map: this.map,
              shouldFocus: false,
            });
            this.openedInfowindow.push([infowindow, solicitationMarker]);
          });

          infowindow.addListener("closeclick", () => {
            for (let i = 0; i < this.openedInfowindow.length; i++) {
              if (this.openedInfowindow[i][0] == infowindow) {
                this.openedInfowindow.splice(i, 1);
                break;
              }
            }
          })

          this.mapSolicitationListMarker.push(solicitationMarker);
        }
      }

      /*for (let i = 0; i < this.solicitationLists.length; i++) {
        // Skip the selected voter
        if (this.solicitationLists[i].voter_id == this.selectedSolicitationList.voter_id) {
          continue;
        }

        let solicitationMarker = new google.maps.Marker({
          map: this.map,
          position: {
            lat: parseFloat(this.solicitationLists[i].map_latitude),
            lng: parseFloat(this.solicitationLists[i].map_longitude),
          },
          icon:"http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
          // position: this.position.latLng,
          // position: { lat: -25.363, lng: 131.044 },
          title: [
            `${this.solicitationLists[i].last_name}, ${this.solicitationLists[i].first_name}`,
            "•",
            `${this.solicitationLists[i].gender} - ${this.solicitationLists[i].age} ans`,
          ].join(" "),
          snippet: `${this.solicitationLists[i].complete_address}, ${this.solicitationLists[i].city}`,
          // animation: google.maps.Animation.BOUNCE,
        });

        const infowindow = new google.maps.InfoWindow({
          content:
            [
              `${this.solicitationLists[i].last_name}, ${this.solicitationLists[i].first_name}`,
              "•",
              `${this.solicitationLists[i].gender} - ${this.solicitationLists[i].age} ans`,
            ].join(" ") +
            `<br/>${this.solicitationLists[i].complete_address}, ${this.solicitationLists[i].city}<br/><a href="/#/my-current-campaign?electeurId=12345">Pointer l'électeur</a>`,
        });

        solicitationMarker.addListener("click", () => {
          infowindow.open({
            anchor: solicitationMarker,
            map: this.map,
            shouldFocus: false,
          });
        });

        this.mapSolicitationListMarker.push(solicitationMarker);
      }*/
    },

    navigateMapToSelectedPosition: async function (item) {
      if (item) {
        this.selectedSolicitationList = item;
      }
      var selectedPosition = {
        lat: this.selectedSolicitationList.map_latitude,
        lng: this.selectedSolicitationList.map_longitude
      }
      this.map.panTo(selectedPosition);
      this.bottomNav = 2;
    },

    showOpenedInfoWindows: function () {
      for (let i = 0; i < this.openedInfowindow.length; i++) {
        this.openedInfowindow[i][0].open({
          anchor: this.openedInfowindow[i][1],
          map: this.map,
          shouldFocus: false,
        });
      }
    },

    refreshMap: async function () {
      const map = await this.$refs.gmapRef.$mapPromise;
      map.setOptions({
        mapTypeControlOptions: {
          position: this.google.maps.ControlPosition.TOP_CENTER,
        },
      });
      await this.refreshPosition();
      this.map = map;
      this.createMyPositionMarker();
      this.createSelectedSolicitationListMaker();
      this.createSolicitationListMarker();
      this.showOpenedInfoWindows();
      await this.findAndTraceMapDirections();
      this.mapLoaded = true;
    },

    removePushedSolicitations: function () {
      nSQL("solicitation_lists")
        .query("upsert", { locally_deleted: true })
        .where(
          function (sl) {
            return (
              sl.solicitation_assignation_id ===
                this.solicitationAssignation.id &&
              sl.pushed_at > sl.locally_updated_at
            );
          }.bind(this)
        )
        .exec()
        .then(
          function () {
            this.refreshList();
          }.bind(this)
        );
    },

    restoreDeletedSolicitations: function () {
      nSQL("solicitation_lists")
        .query("upsert", { locally_deleted: false })
        .where(["locally_deleted", "=", true])

        .exec()
        .then(
          function () {
            this.refreshList();
          }.bind(this)
        );
    },

    isSolicitationListPushed: function (solicitationList) {
      return (
        solicitationList.pushed_at &&
        (solicitationList.pushed_at > solicitationList.pulled_at ||
          !solicitationList.pulled_at)
      );
    },

    clickPushSolicitationLists: function () {
      if (Exchanger.isOffline()) {
        this.snackbar.message = "Aucune connexion.";
        this.snackbar.enabled = true;
      } else {
        this.pushSolicitationLists();
      }
    },

    pushSolicitationLists: async function () {
      if (!this.solicitationAssignation.id || !this.stats.locally_unpushed) {
        return;
      }

      this.syncing = true;

      const result = await Exchanger.pushSolicitationLists(this.solicitationAssignation);

      if(!result) {
        this.snackbar.message = "Erreur lors de la synchronisation";
        this.snackbar.enabled = true;
      }
    },

    formatTimestamp: function (timestamp, format) {
      const momentLocale = moment.locale();

      moment.locale(this.locale);

      const returnValue = moment(parseInt(timestamp)).format(format || "LLL");

      moment.locale(momentLocale);

      return returnValue;
    },

    resetSelectedSolicitationList: function () {
      this.selectedSolicitationList = {};
      this.selectedSolicitationListHouseholdSolicitationLists = [];
      this.resetSelectedSolicitationListValidation();
    },

    onUpdateBottomNavActive: function () {
      this.resetSelectedSolicitationListValidation();
      this.adjustWindowY();
    },

    adjustWindowY: function () {
      const adjustWindowY = function () {
        this.$vuetify.goTo(
          this.windowYPositions[this.bottomNav] + this.windowYOffset,
          { duration: 0 }
        );
      }.bind(this);

      this.bottomNav === this.windowIndexes.list
        ? setTimeout(adjustWindowY, 200)
        : adjustWindowY();
    },

    checkSelectedSolicitationListEmail: function () {
      if (!this.isValidEmail(this.selectedSolicitationList.email)) {
        this.selectedSolicitationList.send_membership_form_link = false;
        this.selectedSolicitationList.send_election_location = false;
        this.selectedSolicitationList.send_candidate_bio = false;
      }
    },

    escapeHtml: function (html) {
      if (null === html || "" === html) {
        return "";
      }

      const htmlStr = html.toString();
      const replaceMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      };

      return htmlStr.replace(/[&<>"']/g, function (m) {
        return replaceMap[m];
      });
    },

    isValidEmail: function (email) {
      return email && emailRegex.test(email);
    },

    validateSelectedSolicitationList() {
      return this.$refs.selectedSolicitationListForm.validate();
    },

    resetSelectedSolicitationListValidation() {
      this.$refs.selectedSolicitationListForm.resetValidation();
    },

    saveSelectedSolicitationList: async function () {
      if (!this.validateSelectedSolicitationList()) {
        return;
      }

      const affectedSolicitationLists = [this.selectedSolicitationList];
      const toSaveSolicitationListRecords = [];

      for (
        let i = 0,
          len = this.selectedSolicitationListHouseholdSolicitationLists.length;
        i < len;
        i++
      ) {
        let householdSolicitationList =
          this.selectedSolicitationListHouseholdSolicitationLists[i];

        if (
          householdSolicitationList.voter_id !==
          this.selectedSolicitationList.voter_id
        ) {
          if (
            this.selectedSolicitationList.score &&
            !householdSolicitationList.score
          ) {
            householdSolicitationList.score =
              this.selectedSolicitationList.score;
          }

          affectedSolicitationLists.push(householdSolicitationList);
        }
      }

      const freshSolicitationListRecords = await nSQL("solicitation_lists")
        .query(
          "select",
          ["local_id", "locally_updated_attributes"].concat(
            SOLICITATION_LIST_EDITABLE_ATTRIBUTES
          )
        )
        .where(["local_id", "IN", _.map(affectedSolicitationLists, "local_id")])
        .exec();

      const locallyUpdatedAt = moment().valueOf();

      for (let i = 0, len = affectedSolicitationLists.length; i < len; i++) {
        let affectedSolicitationList = affectedSolicitationLists[i];
        let freshSolicitationList = _.find(freshSolicitationListRecords, {
          local_id: affectedSolicitationList.local_id,
        });

        let attributeTimestamps = freshSolicitationList
          ? freshSolicitationList.locally_updated_attributes || {}
          : {};
        let attributeValues = freshSolicitationList
          ? { local_id: affectedSolicitationList.local_id }
          : affectedSolicitationList;

        let changed = !freshSolicitationList;

        for (
          let attrIdx = 0, len = SOLICITATION_LIST_EDITABLE_ATTRIBUTES.length;
          attrIdx < len;
          attrIdx++
        ) {
          let attribute = SOLICITATION_LIST_EDITABLE_ATTRIBUTES[attrIdx];

          if (
            !freshSolicitationList ||
            freshSolicitationList[attribute] !==
              affectedSolicitationList[attribute]
          ) {
            changed = true;
            attributeTimestamps[attribute] = locallyUpdatedAt;
            attributeValues[attribute] = affectedSolicitationList[attribute];
          }
        }

        attributeValues.local_id = affectedSolicitationList.local_id;
        attributeValues.locally_updated_at = locallyUpdatedAt;
        attributeValues.locally_updated_attributes = attributeTimestamps;

        if (changed) {
          toSaveSolicitationListRecords.push(attributeValues);
        }
      }

      if (toSaveSolicitationListRecords.length > 0) {
        const savedSolicitationLists = await nSQL("solicitation_lists")
          .query("upsert", toSaveSolicitationListRecords)
          .exec();

        for (let i = 0, len = savedSolicitationLists.length; i < len; i++) {
          let savedSolicitationList = savedSolicitationLists[i];

          const itemIndex = _.findIndex(this.solicitationLists, {
            local_id: savedSolicitationList.local_id,
          });

          if (-1 === itemIndex) {
            this.solicitationLists.push(savedSolicitationList);
          } else {
            this.solicitationLists.splice(itemIndex, 1, savedSolicitationList);
          }
        }
      }

      this.refreshStats();

      this.bottomNav = this.windowIndexes.list;
      this.adjustWindowY();

      setTimeout(this.resetSelectedSolicitationList.bind(this), 250);
    },

    getScoreByCode: function (code) {
      return _.find(this.scoreChoices, { code: code });
    },

    getSelectedSolicitationListHouseholdSolicitationLists: async function () {
      const householdVoterRecords = await nSQL("solicited_voters")
        .query("select")
        .where([
          ["district_id", "=", this.selectedSolicitationList.district_id],
          "AND",
          ["postal_code", "=", this.selectedSolicitationList.postal_code],
          "AND",
          ["city", "=", this.selectedSolicitationList.city],
          "AND",
          [
            "complete_address",
            "=",
            this.selectedSolicitationList.complete_address,
          ],
        ])
        .exec();

      const householdSolicitationListRecords = await nSQL("solicitation_lists")
        .query("select")
        .where([
          ["district_id", "=", this.selectedSolicitationList.district_id],
          "AND",
          ["postal_code", "=", this.selectedSolicitationList.postal_code],
          "AND",
          ["city", "=", this.selectedSolicitationList.city],
          "AND",
          [
            "complete_address",
            "=",
            this.selectedSolicitationList.complete_address,
          ],
        ])
        .exec();

      const householdSolicitationLists = [];

      for (let i = 0, len = householdVoterRecords.length; i < len; i++) {
        let householdVoterRecord = householdVoterRecords[i];

        if (
          householdVoterRecord.id === this.selectedSolicitationList.voter_id
        ) {
          householdSolicitationLists.push(this.selectedSolicitationList);
        } else {
          let householdSolicitationListRecord = _.find(
            householdSolicitationListRecords,
            {
              solicitation_assignation_id:
                this.selectedSolicitationList.solicitation_assignation_id,
              voter_id: householdVoterRecord.id,
            }
          );

          if (!householdSolicitationListRecord) {
            householdSolicitationListRecord = Object.assign(
              householdVoterRecord,
              {
                local_id: [
                  this.selectedSolicitationList.solicitation_assignation_id,
                  householdVoterRecord.id,
                ].join("-"),
                solicitation_assignation_id:
                  this.selectedSolicitationList.solicitation_assignation_id,
                voter_id: householdVoterRecord.id,
              }
            );

            delete householdSolicitationListRecord.id;
            delete householdSolicitationListRecord.pulled_at;
            delete householdSolicitationListRecord.updated_at;
          }

          householdSolicitationLists.push(householdSolicitationListRecord);
        }
      }

      return householdSolicitationLists;
    },

    selectSolicitationList: async function (
      solicitationList,
      fromHousehold,
      bottomNav
    ) {
      this.resetSelectedSolicitationListValidation();

      if (fromHousehold) {
        this.selectedSolicitationList = solicitationList;
      } else {
        this.selectedSolicitationList = Object.assign({}, solicitationList);
        this.selectedSolicitationListHouseholdSolicitationLists =
          await this.getSelectedSolicitationListHouseholdSolicitationLists();

        if (typeof bottomNav !== "undefined" && null !== bottomNav) {
          this.bottomNav = bottomNav;
          this.$vuetify.goTo(this.windowYPositions[this.bottomNav], {
            duration: 0,
          });
        }
      }
    },

    refreshSolicitationAssignation: function () {
      this.refreshStats();
      this.refreshList();
    },

    refreshStats: function () {
      if (!this.solicitationAssignation.id) {
        return;
      }

      const statsMetricNames = [
        "total_qualified",
        "total_scored",
        "total_remaining",
        "pushed_at",
      ];

      for (let i = 0, len = statsMetricNames.length; i < len; i++) {
        let metricName = statsMetricNames[i];
        let settingName = `solicitation-assignations:${this.solicitationAssignation.id}:${metricName}`;

        nSQL("settings")
          .query("select")
          .where(["name", "=", settingName])
          .exec()
          .then(
            function (rows) {
              this.stats[metricName] = rows[0] ? rows[0].value || null : null;
            }.bind(this)
          );
      }

      nSQL("solicitation_lists")
        .query("select", ["COUNT(*) AS locally_updated"])
        .where(
          function (sl) {
            return (
              sl.solicitation_assignation_id ===
                this.solicitationAssignation.id && sl.locally_updated_at
            );
          }.bind(this)
        )
        .exec()
        .then(
          function (rows) {
            this.stats.locally_updated = rows[0].locally_updated;
          }.bind(this)
        );

      nSQL("solicitation_lists")
        .query("select", ["COUNT(*) AS locally_unpushed"])
        .where(
          function (sl) {
            return (
              sl.solicitation_assignation_id ===
                this.solicitationAssignation.id &&
              sl.locally_updated_at &&
              (!sl.pushed_at || sl.locally_updated_at > sl.pushed_at)
            );
          }.bind(this)
        )
        .exec()
        .then(
          function (rows) {
            this.stats.locally_unpushed = rows[0].locally_unpushed;
          }.bind(this)
        );

      nSQL("solicitation_lists")
        .query("select", ["COUNT(*) AS locally_pushed"])
        .where(
          function (sl) {
            return (
              sl.solicitation_assignation_id ===
                this.solicitationAssignation.id &&
              sl.pushed_at > sl.locally_updated_at
            );
          }.bind(this)
        )
        .exec()
        .then(
          function (rows) {
            this.stats.locally_pushed = rows[0].locally_pushed;
          }.bind(this)
        );

      setTimeout(
        function () {
          this.syncing = false;
        }.bind(this),
        200
      );
    },

    refreshList: async function () {
      if (!this.solicitationAssignation.id) {
        return;
      }

      const pulledAtSettingName = `solicitation-assignations:${this.solicitationAssignation.id}:pulled_at`;
      const pulledAtSettingRecord =
        (
          await nSQL("settings")
            .query("select")
            .where(["name", "=", pulledAtSettingName])
            .exec()
        )[0] || null;

      this.isInitialPulling = !pulledAtSettingRecord;

      this.solicitationLists = await nSQL("solicitation_lists")
        .query("select")
        .where([
          "solicitation_assignation_id",
          "=",
          this.solicitationAssignation.id,
        ])
        .exec();

      this.listLoaded =
        pulledAtSettingRecord || this.solicitationLists.length > 0;
    },

    isOdd: function (number) {
      return number % 2 !== 0;
    },
  },
};
</script>

<style>
.map-canvas {
  width: 100%;
  height: calc(100% - 0px);
}
.v-window.fill-height {
  padding-bottom: constant(safe-area-inset-top); /* iOS 11.0 */
  padding-bottom: env(safe-area-inset-top); /* iOS 11.2 */
}
.v-window.fill-height .v-window__container,
.v-window.fill-height .v-window__container > .v-window-item {
  height: calc(100% - 32px);
}
.bottom-navigation {
  margin-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  margin-bottom: env(safe-area-inset-bottom); /* iOS 11.2 */
}
.btn-directions {
  margin-bottom: 64px;
  margin-right: 48px;
}
.btn-my-position {
  margin-bottom: 64px;
}

.map-options-background {
  position: absolute;
  top: 1%;
  left: 1%;
  background-color: white;
  width: 200px;
  height: 250px;
  border-radius: 2.5%;
  box-shadow: 1.5px 1.5px rgb(189, 189, 189);
}

.exit-map-options-button {
  top: 0%;
  right: 0%;
}

.exit-map-options-button::before {
  color: transparent;
}

.exit-map-options-icon:hover {
  color: black !important;
}

.checkbox-padding {
  padding-left: 8px;
  padding-right: 10px;
}

.switch-electors {
  position: absolute;
  top: 10%;
  left: 35%;
}

.switch-tagged-electors {
  position: absolute;
  top: 25%;
  left: 35%;
}

.switch-path {
  position: absolute;
  top: 10%;
  left: 35%;
}

.switchProfilButton {
  position: absolute;
  right: 5%;
  bottom: 5%;
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.switchProfilButton:hover {
  background-color: rgb(184, 184, 184);
}

.mdi--crosshairs-gps {
  display: inline-block;
  width: 2em;
  height: 2em;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m-8.95 5H1v-2h2.05C3.5 6.83 6.83 3.5 11 3.05V1h2v2.05c4.17.45 7.5 3.78 7.95 7.95H23v2h-2.05c-.45 4.17-3.78 7.5-7.95 7.95V23h-2v-2.05C6.83 20.5 3.5 17.17 3.05 13M12 5a7 7 0 0 0-7 7a7 7 0 0 0 7 7a7 7 0 0 0 7-7a7 7 0 0 0-7-7'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  display: block;
  margin: 0 auto;
}
</style>
